 

// import React, { useState, useEffect } from "react";

// const Services = () => {
//   const [activeTab, setActiveTab] = useState("Banking");
//   const [animate, setAnimate] = useState(false);

//   useEffect(() => {
//     setAnimate(true);
//     const timer = setTimeout(() => setAnimate(false), 800);
//     return () => clearTimeout(timer);
//   }, [activeTab]);

//   const data = {
//     Banking: [
//       {
//         title: "Banking Products",
//         desc: "Our products enable banks to transform their operations, bring innovation, drive profitability, optimize resources, and build future-ready processes.",
//         color: "#e3f2fd",
//       },
//       {
//         title: "Lending and Leasing",
//         desc: "Specialized business vertical in BFS space, with solutions powered by technology and digital prowess.",
//         color: "#fff3e0",
//       },
//       {
//         title: "Payments and Transaction Banking",
//         desc: "End-to-end business consulting, platform transformation, implementation, customization, and managed services.",
//         color: "#f3e5f5",
//       },
//     ],
//     "Financial Services": [
//       {
//         title: "Retirement and Pensions",
//         desc: "Driving customer outcomes with operational models, digital platforms, and personalized experiences.",
//         color: "#e8f5e9",
//       },
//       {
//         title: "Wealth and Asset Management",
//         desc: "Supporting wealth managers with innovative client experiences, digital assets, and ESG regulations.",
//         color: "#fce4ec",
//       },
//       {
//         title: "GRC",
//         desc: "Global Risk and Compliance services for governance, risk mitigation, and regulatory requirements.",
//         color: "#ede7f6",
//       },
//     ],
//     "Digital Banking": [
//       {
//         title: "Customer Engagement & Digital Experience",
//         desc: "Modern banking extends beyond products to deliver lasting customer experiences with services, operations, and data.",
//         color: "#fff9c4",
//       },
//       {
//         title: "Enterprise Tech Transformations",
//         desc: "Cutting-edge enterprise tech tailored to optimize efficiency and drive digital future growth.",
//         color: "#c8e6c9",
//       },
//       {
//         title: "Digital Security & Fraud Prevention",
//         desc: "Comprehensive security solutions to protect digital banking platforms from emerging threats and ensure customer data protection.",
//         color: "#ffcdd2",
//       },
//     ],
//   };

//   const styles = {
//     container: {
//       padding: "40px",
//       fontFamily: "Arial, sans-serif",
//       maxWidth: "100%",
//       margin: "0 auto",
//       backgroundColor: "white",
//     },
//     heading: {
//       fontSize: "36px",
//       fontWeight: "bold",
//       marginBottom: "20px",
//       textAlign: "left",
//       letterSpacing:"0px",
//     },
//     tabs: {
//       display: "flex",
//       gap: "30px",
//       marginBottom: "30px",
//       flexWrap: "wrap",
//     },
//     tab: (isActive) => ({
//       fontSize: "18px",
//       fontWeight: isActive ? "bold" : "normal",
//       cursor: "pointer",
//       borderBottom: isActive ? "2px solid red" : "none",
//       color: isActive ? "#000" : "gray",
//       paddingBottom: "5px",
//       transition: "0.3s",
//     }),
//     cards: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//       gap: "20px",
//     },
//     card: (bgColor, index) => ({
//       background: bgColor,
//       padding: "20px",
//       borderRadius: "10px",
//       boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//       transform: animate
//         ? `translateY(${index % 2 === 0 ? "30px" : "-30px"})`
//         : "translateY(0)",
//       opacity: animate ? 0 : 1,
//       animation: animate ? `waveIn 0.8s ease forwards ${index * 0.2}s` : "none",
//       minHeight: "230px",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "space-between",
//     }),
//     cardTitle: {
//       fontSize: "20px",
//       fontWeight: "bold",
//       marginBottom: "15px",
//       letterSpacing: "0px",
//     },
//     cardText: {
//       fontSize: "16px",
//       lineHeight: "1.5",
//       marginBottom: "15px",
//       flexGrow: 1,
//       textAlign: "justify",
//     },
//     learnMore: {
//       fontWeight: "bold",
//       fontSize: "14px",
//       cursor: "pointer",
//       alignSelf: "flex-start", // Align to bottom
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h1 style={styles.heading}>Our Services</h1>

//       {/* Tabs */}
//       <div style={styles.tabs}>
//         {Object.keys(data).map((tab) => (
//           <div
//             key={tab}
//             style={styles.tab(activeTab === tab)}
//             onClick={() => setActiveTab(tab)}
//           >
//             {tab}
//           </div>
//         ))}
//       </div>

//       {/* Cards */}
//       <div style={styles.cards}>
//         {data[activeTab].map((item, index) => (
//           <div key={index} style={styles.card(item.color, index)}>
//             <div>
//               <h2 style={styles.cardTitle}>{item.title}</h2>
//               <p style={styles.cardText}>{item.desc}</p>
//             </div>
//             {/* <span style={styles.learnMore}>LEARN MORE</span> */}
//           </div>
//         ))}
//       </div>

//       {/* Inline keyframes */}
//       <style>
//         {`
//           @keyframes waveIn {
//             0% { transform: translateY(50px); opacity: 0; }
//             100% { transform: translateY(0); opacity: 1; }
//           }
          
//           @media (max-width: 768px) {
//             .services-container {
//               padding: 20px;
//             }
            
//             .services-heading {
//               font-size: 28px;
//             }
            
//             .services-tabs {
//               gap: 15px;
//             }
            
//             .services-cards {
//               grid-template-columns: 1fr;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default Services;



import React, { useState, useEffect } from "react";

const Services = () => {
  const [activeTab, setActiveTab] = useState("Banking");
  const [animate, setAnimate] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 800);
    
    // Handle responsiveness
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, [activeTab]);

  const data = {
    Banking: [
      {
        title: "Banking Products",
        desc: "Our products enable banks to transform their operations, bring innovation, drive profitability, optimize resources, and build future-ready processes.",
        color: "#e3f2fd",
      },
      {
        title: "Lending and Leasing",
        desc: "Specialized business vertical in BFS space, with solutions powered by technology and digital prowess.",
        color: "#fff3e0",
      },
      {
        title: "Payments and Transaction Banking",
        desc: "End-to-end business consulting, platform transformation, implementation, customization, and managed services.",
        color: "#f3e5f5",
      },
    ],
    "Financial Services": [
      {
        title: "Retirement and Pensions",
        desc: "Driving customer outcomes with operational models, digital platforms, and personalized experiences.",
        color: "#e8f5e9",
      },
      {
        title: "Wealth and Asset Management",
        desc: "Supporting wealth managers with innovative client experiences, digital assets, and ESG regulations.",
        color: "#fce4ec",
      },
      {
        title: "GRC",
        desc: "Global Risk and Compliance services for governance, risk mitigation, and regulatory requirements.",
        color: "#ede7f6",
      },
    ],
    "Digital Banking": [
      {
        title: "Customer Engagement & Digital Experience",
        desc: "Modern banking extends beyond products to deliver lasting customer experiences with services, operations, and data.",
        color: "#fff9c4",
      },
      {
        title: "Enterprise Tech Transformations",
        desc: "Cutting-edge enterprise tech tailored to optimize efficiency and drive digital future growth.",
        color: "#c8e6c9",
      },
      {
        title: "Digital Security & Fraud Prevention",
        desc: "Comprehensive security solutions to protect digital banking platforms from emerging threats and ensure customer data protection.",
        color: "#ffcdd2",
      },
    ],
  };

  const styles = {
    container: {
      padding: isMobile ? "20px" : "40px",
      fontFamily: "Arial, sans-serif",
      maxWidth: "100%",
      margin: "0 auto",
      backgroundColor: "white",
    },
    heading: {
      fontSize: isMobile ? "28px" : "36px",
      fontWeight: "bold",
      marginBottom: "20px",
      textAlign: isMobile ? "center" : "left",
      letterSpacing: "0px",
    },
    tabs: {
      display: "flex",
      gap: isMobile ? "15px" : "30px",
      marginBottom: "30px",
      flexWrap: "wrap",
      justifyContent: isMobile ? "center" : "flex-start",
    },
    tab: (isActive) => ({
      fontSize: isMobile ? "16px" : "18px",
      fontWeight: isActive ? "bold" : "normal",
      cursor: "pointer",
      borderBottom: isActive ? "2px solid red" : "none",
      color: isActive ? "#000" : "gray",
      paddingBottom: "5px",
      transition: "0.3s",
      whiteSpace: "nowrap",
    }),
    cards: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
    },
    card: (bgColor, index) => ({
      background: bgColor,
      padding: isMobile ? "15px" : "20px",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      transform: animate
        ? `translateY(${index % 2 === 0 ? "30px" : "-30px"})`
        : "translateY(0)",
      opacity: animate ? 0 : 1,
      animation: animate ? `waveIn 0.8s ease forwards ${index * 0.2}s` : "none",
      minHeight: isMobile ? "180px" : "230px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    }),
    cardTitle: {
      fontSize: isMobile ? "18px" : "20px",
      fontWeight: "bold",
      marginBottom: "15px",
      letterSpacing: "0px",
    },
    cardText: {
      fontSize: isMobile ? "14px" : "16px",
      lineHeight: "1.5",
      marginBottom: "15px",
      flexGrow: 1,
      textAlign: "justify",
    },
    learnMore: {
      fontWeight: "bold",
      fontSize: "14px",
      cursor: "pointer",
      alignSelf: "flex-start",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Our Services</h1>

      {/* Tabs */}
      <div style={styles.tabs}>
        {Object.keys(data).map((tab) => (
          <div
            key={tab}
            style={styles.tab(activeTab === tab)}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      {/* Cards */}
      <div style={styles.cards}>
        {data[activeTab].map((item, index) => (
          <div key={index} style={styles.card(item.color, index)}>
            <div>
              <h2 style={styles.cardTitle}>{item.title}</h2>
              <p style={styles.cardText}>{item.desc}</p>
            </div>
            {/* <span style={styles.learnMore}>LEARN MORE</span> */}
          </div>
        ))}
      </div>

      {/* Inline keyframes */}
      <style>
        {`
          @keyframes waveIn {
            0% { transform: translateY(50px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default Services;